import React, { useRef, useState } from 'react';
import { Button } from '../ui/button';
import { Loader2, Upload } from 'lucide-react';
import { toast } from '../../hooks/use-toast';
import MediaLibraryDialog from './MediaLibraryDialog';

const UploadMediaButton = ({ onUploaded, idx, accept = 'image/*,video/mp4,video/webm,video/quicktime', label = 'CARICA', library = true }) => {
  const libraryKind = accept.startsWith('video') ? 'video' : accept === 'image/*' ? 'image' : 'all';
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (file.size > 50 * 1024 * 1024) {
      toast({ title: 'File troppo grande', description: 'Massimo 50 MB', variant: 'destructive' });
      return;
    }
    setUploading(true);
    try {
      const form = new FormData();
      form.append('file', file);
      const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/upload`, { method: 'POST', body: form });
      if (!r.ok) throw new Error('upload');
      const d = await r.json();
      onUploaded(d.url);
      toast({ title: 'Caricato!', description: file.name });
    } catch {
      toast({ title: 'Errore upload', description: 'Riprova o incolla un URL', variant: 'destructive' });
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={handleFile} data-testid={`upload-input-${idx}`} />
      <Button type="button" size="sm" variant="outline" disabled={uploading} onClick={() => inputRef.current?.click()}
        data-testid={`upload-btn-${idx}`} className="border-gray-700 text-white hover:bg-gray-800 text-xs h-9 whitespace-nowrap">
        {uploading ? <Loader2 size={13} className="mr-1 animate-spin" /> : <Upload size={13} className="mr-1" />}
        {label}
      </Button>
      {library && <MediaLibraryDialog idx={idx} accept={libraryKind} onSelect={onUploaded} />}
    </>
  );
};

export default UploadMediaButton;
